import { render } from "./Scenarios.vue?vue&type=template&id=64d0fbea&scoped=true"
import script from "./Scenarios.vue?vue&type=script&lang=js"
export * from "./Scenarios.vue?vue&type=script&lang=js"

import "./Scenarios.vue?vue&type=style&index=0&id=64d0fbea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d0fbea"]])

export default __exports__